import { render, staticRenderFns } from "./BgImageWidget.vue?vue&type=template&id=9d393d90&"
import script from "./BgImageWidget.vue?vue&type=script&lang=js&"
export * from "./BgImageWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\DIA-funsporthandel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d393d90')) {
      api.createRecord('9d393d90', component.options)
    } else {
      api.reload('9d393d90', component.options)
    }
    module.hot.accept("./BgImageWidget.vue?vue&type=template&id=9d393d90&", function () {
      api.rerender('9d393d90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/widgets/BgImageWidget.vue"
export default component.exports